import {
  Box,
  Checkbox,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import DataTable from "../../common/dataTable";
import profileImage from "../../assets/images/profile.png";
import signatureImage from "../../assets/images/signature.png";
import PrimaryButton from "../../common/primaryButton";
import { useNavigate } from "react-router-dom";
import { setupFullscreenBlock } from "../../common/disableEscKey";
import RemainingTimeModal from "../liveTest/remainingTimeModal";
import commonActions from "../../Redux/common/actions";
import { useDispatch, useSelector } from "react-redux";
import { handleEncodeJson } from "../../utils/encodeDecodeJson";
import examActions from "../../Redux/exam/actions";
import SecondaryButton from "../../common/secondaryButton";
import dayjs from "dayjs";
import sampleTestActions from "../../Redux/sampleTest/actions";
import Cookies from "js-cookie";
import NotificationModal from "../../common/notificationModal";
import useFetchCandidateTokenDetails from "../../hooks/useFetchCandidateTokenDetails";
import { auditLog } from "../../utils/auditLog";

export default function Index() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { instructions, heartBeat, projectDetails } = useSelector(
    (state) => state.examReducer
  );
  const [candidateTokenDetails, setCandidateTokenDetails] = useState(null);
  const [checked, setChecked] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [timeToStart, setTimeToStart] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const [triggeredMinutes, setTriggeredMinutes] = useState([]);
  const [selectedLanguage, setSelectedlanguage] = useState(null);
  const [value, setValue] = useState(1);
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  let timeDuration = candidateTokenDetails?.configuration?.timeDuration;
  let timeDurationForScribe =
    candidateTokenDetails?.configuration?.timeDurationForScribe;
  timeDuration = String(timeDuration) || "00:00";
  timeDurationForScribe = String(timeDurationForScribe) || "00:00";
  let isScribe = candidateTokenDetails?.user?.scribeRequired;
  let hours = 0,
    minutes = 0;

  let validTimeDuration = isScribe ? timeDurationForScribe : timeDuration;
  if (validTimeDuration.includes(":")) {
    [hours, minutes] = validTimeDuration.split(":").map(Number);
  } else {
    minutes = Number(validTimeDuration);
  }
  const totalMinutes = hours * 60 + minutes;
  const numberOfQuestions =
    candidateTokenDetails?.configuration?.numberOfQuestions;
  const formattedLanguages = candidateTokenDetails?.configuration?.languages
    .map((lang) => lang.charAt(0).toUpperCase() + lang.slice(1))
    .join(" / ");

  const formattedStartTime = dayjs(
    candidateTokenDetails?.configuration?.startTime
  )
    .subtract(5, "hour")
    .subtract(30, "minute")
    .format("hh:mm A");
  const formattedEndTime = dayjs(candidateTokenDetails?.configuration?.endTime)
    .subtract(5, "hour")
    .subtract(30, "minute")
    .format("hh:mm A");
  const timeRange = `${formattedStartTime} - ${formattedEndTime}`;

  const examEndTime = localStorage.getItem("examEndTime");
  const examEndDate = new Date(examEndTime);
  examEndDate.setTime(examEndDate.getTime() + (5 * 60 + 30) * 60 * 1000);
  let isMock = projectDetails?.mockMode;
  const updatedExamEndTime = isMock
    ? candidateTokenDetails?.configuration?.endTime
    : examEndDate.toISOString();
  const isLateLoginAllowed =
    candidateTokenDetails?.configuration?.lateLoginAllowed;

  useEffect(() => {
    if (!candidateTokenDetails?.configuration?.startTime) return;

    const startTime = new Date(candidateTokenDetails.configuration.startTime);

    const updateTimeToStart = () => {
      const now = new Date(heartBeat?.data);
      const difference = startTime - now;

      if (difference > 0) {
        const hours = Math.floor(difference / (1000 * 60 * 60));
        const minutes = Math.floor(
          (difference % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);
        setTimeToStart({ hours, minutes, seconds });
      } else {
        if (!showNotification && difference <= 0) {
          dispatch({
            type: commonActions.SET_SHOW_MODAL,
            payload: { show: true, type: null, method: "N", data: null },
          });
          setShowNotification(true);
        }
        setTimeToStart({ hours: 0, minutes: 0, seconds: 0 });
      }
    };
    updateTimeToStart();
    const interval = setInterval(updateTimeToStart, 1000);

    return () => clearInterval(interval);
  }, [candidateTokenDetails, heartBeat]);

  useFetchCandidateTokenDetails({ setCandidateTokenDetails });

  useEffect(() => {
    dispatch({ type: examActions.GET_INSTRUCTIONS });
  }, []);

  const handleChange = (language, newValue) => {
    setValue(newValue);
    setSelectedlanguage(language);
    auditLog({
      data: {
        RegistrationNumber: `${candidateTokenDetails?.user?.id}`,
        RollNumber: `${candidateTokenDetails?.user?.rollNo}`,
        Activity: `User selected ${language} Instruction language`,
        IPaddress: "",
      },
      dispatch,
      heartBeat,
    });
  };

  const filteredInstructions = instructions?.instructions?.filter(
    (instruction) => instruction.language === selectedLanguage
  );

  useEffect(() => {
    if (instructions?.instructions && instructions?.instructions[0]?.language) {
      setSelectedlanguage("english" || instructions?.instructions[0]?.language);
    }
  }, [instructions?.instructions]);

  const columns = [
    { id: "srno", label: "Sr. No." },
    { id: "testname", label: "Test Name" },
    { id: "noofquestion", label: "No. of Question" },
    { id: "language", label: "Language of paper" },
    { id: "duration", label: "Exam Duration" },
    { id: "time", label: "Time of Exam" },
  ];

  const mockColumns = [
    { id: "srno", label: "Sr. No." },
    { id: "testname", label: "Test Name" },
    { id: "noofquestion", label: "No. of Question" },
    { id: "language", label: "Language of paper" },
    { id: "duration", label: "Exam Duration" },
    { id: "time", label: "Time of Exam" },
    { id: "action", label: "Action" },
  ];

  const data = [
    {
      srno: 1,
      testname: "Computer Based Test",
      noofquestion: numberOfQuestions,
      language: formattedLanguages,
      duration: `${totalMinutes} mins`,
      time: timeRange,
    },
  ];

  const fontStyle = {
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "13px",
  };

  const handleLiveTest = async () => {
    dispatch({
      type: commonActions.SET_SHOW_MODAL,
      payload: { show: false, type: null, method: "S", data: null },
    });
    auditLog({
      data: {
        RegistrationNumber: `${candidateTokenDetails?.user?.id}`,
        RollNumber: `${candidateTokenDetails?.user?.rollNo}`,
        Activity: "User selected Start Exam",
        IPaddress: "",
      },
      dispatch,
      heartBeat,
    });
    setupFullscreenBlock();
    await document.documentElement.requestFullscreen();
    sessionStorage.setItem("visitedQuestions", JSON.stringify(""));
    localStorage.setItem("examStartTime", heartBeat?.data);
    const formData = {
      imageSize: "L",
      language: selectedLanguage
        ? `${selectedLanguage}`
        : instructions?.instructions[0]?.language ||
          candidateTokenDetails?.configuration?.languages[0],
    };
    const encodedData = await handleEncodeJson({ encodeJSON: formData });
    dispatch({
      type: examActions.GET_EXAM_QUESTIONS,
      payload: {
        data: encodedData,
        formData: formData,
        navigate: navigate,
      },
    });
  };

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  const handleMockTest = async () => {
    setupFullscreenBlock();
    await document.documentElement.requestFullscreen();
    const formData = {
      imageSize: "L",
      language: selectedLanguage
        ? `${selectedLanguage}`
        : instructions?.instructions[0]?.language ||
          candidateTokenDetails?.configuration?.languages[0],
    };
    const encodedData = await handleEncodeJson({ encodeJSON: formData });
    dispatch({
      type: examActions.GET_EXAM_QUESTIONS,
      payload: {
        data: encodedData,
        formData: formData,
        navigate: navigate,
        mockMode: projectDetails?.mockMode,
      },
    });
  };

  useEffect(() => {
    const startTime = Date.parse(
      candidateTokenDetails?.configuration?.startTime
    );
    const endTime = isLateLoginAllowed
      ? Date.parse(candidateTokenDetails?.configuration?.endTime)
      : Date.parse(
          updatedExamEndTime ?? candidateTokenDetails?.configuration?.endTime
        );
    const updateTimer = () => {
      const currentTime = new Date(heartBeat?.data);

      if (currentTime < startTime) {
        const totalDuration = endTime - startTime;
        const hours = Math.floor(totalDuration / (1000 * 60 * 60));
        const minutes = Math.floor(
          (totalDuration % (1000 * 60 * 60)) / (1000 * 60)
        );
        const totalSeconds = Math.floor(totalDuration / 1000);
        const seconds = totalSeconds % 60;
        setTimeLeft({ hours, minutes, seconds });
        return;
      }

      if (currentTime >= endTime) {
        setTimeLeft({ hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      if (currentTime >= startTime) {
        const difference = endTime - currentTime;
        const hours = Math.floor(difference / (1000 * 60 * 60));
        const minutes = Math.floor(
          (difference % (1000 * 60 * 60)) / (1000 * 60)
        );
        const totalSeconds = Math.floor(difference / 1000);
        const seconds = totalSeconds % 60;
        setTimeLeft({ hours, minutes, seconds });
      }
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, [candidateTokenDetails, heartBeat]);

  const handleSampleTest = async () => {
    dispatch({
      type: commonActions.SET_SHOW_MODAL,
      payload: { show: false, type: null, method: "S", data: null },
    });
    auditLog({
      data: {
        RegistrationNumber: `${candidateTokenDetails?.user?.id}`,
        RollNumber: `${candidateTokenDetails?.user?.rollNo}`,
        Activity: "User selected Sample Test",
        IPaddress: "",
      },
      dispatch,
      heartBeat,
    });
    setupFullscreenBlock();
    await document.documentElement.requestFullscreen();
    const formData = {
      imageSize: "L",
      language: selectedLanguage
        ? `${selectedLanguage}`
        : instructions?.instructions[0]?.language ||
          candidateTokenDetails?.configuration?.languages[0],
    };
    const encodedData = await handleEncodeJson({ encodeJSON: formData });
    dispatch({
      type: sampleTestActions.GET_SAMPLE_QUESTIONS,
      payload: {
        data: encodedData,
        formData: formData,
        navigate: navigate,
      },
    });
  };

  useEffect(() => {
    const notificationTimes =
      candidateTokenDetails?.configuration?.reminders || [];
    if (
      timeToStart?.hours === 0 &&
      timeToStart?.seconds === 0 &&
      candidateTokenDetails?.configuration &&
      candidateTokenDetails?.configuration?.reminders &&
      notificationTimes.includes(timeToStart?.minutes) &&
      !triggeredMinutes.includes(timeToStart?.minutes)
    ) {
      dispatch({
        type: commonActions.SET_ALERT,
        payload: {
          status: "success",
          show: true,
          message: `Exam starts in ${timeToStart?.minutes} minutes`,
        },
      });
      setTimeout(() => {
        dispatch({
          type: commonActions.SET_ALERT,
          payload: {
            status: null,
            show: false,
            message: null,
          },
        });
      }, 5000);
      setTriggeredMinutes((prev) => [...prev, timeToStart?.minutes]);
    }
  }, [timeToStart, candidateTokenDetails?.configuration?.reminders]);

  useEffect(() => {
    dispatch({
      type: examActions.GET_PROJECT_DETAILS,
      payload: {
        data: {
          project: `${Cookies.get("test_engine_project")}`,
        },
        navigate: navigate,
      },
    });
  }, []);

  let venue = sessionStorage.getItem("venue");

  useEffect(() => {
    dispatch({ type: examActions.GET_HEART_BEAT });
  }, []);

  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const checkFullscreen = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    checkFullscreen();

    document.addEventListener("fullscreenchange", checkFullscreen);

    return () => {
      document.removeEventListener("fullscreenchange", checkFullscreen);
    };
  }, []);

  return (
    <>
      <Grid
        container
        p={4}
        sx={{
          backgroundColor: "rgba(255, 255, 255, 1)",
          height: venue && !isFullscreen ? "115vh" : "100vh",
        }}
        // onClick={async () => {
        //   await document.documentElement.requestFullscreen();
        // }}
      >
        <Grid
          container
          p={1}
          sx={{
            border: "1px solid rgba(0, 0, 0, 0.2)",
            height: "188px",
            width: "100%",
            borderRadius: "8px",
          }}
        >
          <Grid item md={2}>
            <Grid sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography varient="caption" sx={{ fontSize: "12px" }}>
                  Photo uploaded
                </Typography>
                <Box
                  component={"img"}
                  src={
                    venue && !isMock
                      ? `${sessionStorage.getItem("api_url")}/${
                          candidateTokenDetails?.user?.photoPath
                        }`
                      : projectDetails?.mockMode
                      ? profileImage
                      : candidateTokenDetails?.user?.photoPath
                  }
                  alt="profile image"
                  sx={{ height: "97px", width: "auto" }}
                />
              </Box>
              {candidateTokenDetails?.configuration?.biometricMethod && (
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <Typography varient="caption" sx={{ fontSize: "12px" }}>
                    Photo clicked
                  </Typography>
                  <Box
                    component={"img"}
                    src={candidateTokenDetails?.user?.photoPath}
                    alt="profile image"
                    sx={{ height: "97px", width: "auto" }}
                  />
                </Box>
              )}
            </Grid>
            <Box
              sx={{ width: "188px", height: "38px", border: "1px solid black" }}
              mt={1}
            >
              <Box
                component={"img"}
                src={
                  venue && !isMock
                    ? `${sessionStorage.getItem("api_url")}/${
                        candidateTokenDetails?.user?.signaturePath
                      }`
                    : projectDetails?.mockMode
                    ? signatureImage
                    : candidateTokenDetails?.user?.signaturePath
                }
                alt="signature image"
                sx={{ height: "36px", width: "auto" }}
              />
            </Box>
          </Grid>
          <Grid item md={8} sx={12}>
            <Grid container p={4} spacing={2}>
              <Grid item md={3}>
                <Typography style={fontStyle}>
                  <b>Center name</b>
                </Typography>
              </Grid>
              <Grid item md={3}>
                <Typography style={fontStyle}>
                  : {candidateTokenDetails?.configuration?.venueName}
                </Typography>
              </Grid>

              <Grid item md={3}>
                <Typography style={fontStyle}>
                  <b>Enrollment no</b>
                </Typography>
              </Grid>
              <Grid item md={3}>
                <Typography style={fontStyle}>
                  :{" "}
                  {projectDetails?.mockMode
                    ? "12345"
                    : candidateTokenDetails?.user?.rollNo}
                </Typography>
              </Grid>

              <Grid item md={3}>
                <Typography style={fontStyle}>
                  <b>Name</b>
                </Typography>
              </Grid>
              <Grid item md={3}>
                <Typography style={fontStyle}>
                  :{" "}
                  {projectDetails?.mockMode
                    ? candidateTokenDetails?.candidate?.candidateName
                    : candidateTokenDetails?.user?.candidateName}
                </Typography>
              </Grid>

              <Grid item md={3}>
                <Typography style={fontStyle}>
                  <b>Maximum Marks</b>
                </Typography>
              </Grid>
              <Grid item md={3}>
                <Typography style={fontStyle}>
                  : {candidateTokenDetails?.configuration?.maxMarks}
                </Typography>
              </Grid>

              <Grid item md={3}>
                <Typography style={fontStyle}>
                  <b>Exam Date</b>
                </Typography>
              </Grid>
              <Grid item md={3}>
                <Typography style={fontStyle}>
                  :{" "}
                  {dayjs(
                    candidateTokenDetails?.configuration?.startTime
                  ).format("DD MMM, YYYY")}
                </Typography>
              </Grid>

              <Grid item md={3}>
                <Typography style={fontStyle}>
                  <b>Exam Duration</b>
                </Typography>
              </Grid>
              <Grid item md={3}>
                <Typography style={fontStyle}>: {totalMinutes} mins</Typography>
              </Grid>

              <Grid item md={3}>
                <Typography style={fontStyle}>
                  <b>Exam Name</b>
                </Typography>
              </Grid>
              <Grid item md={3}>
                <Typography style={fontStyle}>
                  : {candidateTokenDetails?.configuration?.courseName}
                </Typography>
              </Grid>
              <Grid item md={3}>
                <Typography style={fontStyle}>
                  <b>Exam Time</b>
                </Typography>
              </Grid>
              <Grid item md={3}>
                <Typography style={fontStyle}>: {timeRange}</Typography>
              </Grid>
            </Grid>
          </Grid>
          <Divider orientation="vertical" variant="middle" flexItem />

          <Grid
            item
            md={1.8}
            sx={12}
            p={4}
            pb={1.5}
            pt={1.5}
            display={"flex"}
            flexDirection={"column"}
            justifyContent={"space-between"}
          >
            <Box
              sx={{
                background: "#fff",
                height: "35px",
                width: "130px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                filter: "drop-shadow(0 4px 4px rgba(0, 0, 0, 0.12))",
              }}
            >
              {" "}
              <Typography
                sx={{
                  color: isOnline
                    ? "rgba(84, 179, 55, 1)"
                    : "rgba(234, 104, 58, 1)",
                  display: "flex",
                  alignItems: "center",
                  fontWeight: 500,
                }}
              >
                <span style={{ fontSize: "50px", fontWeight: "bold" }}>•</span>
                &nbsp;{isOnline ? "Connected" : "Disconnected"}
              </Typography>
            </Box>
            <Box>
              {timeToStart?.hours === 0 &&
              timeToStart?.minutes === 0 &&
              timeToStart?.seconds === 0 ? (
                <Typography
                  style={{
                    color: "rgba(63, 65, 209, 1)",
                    fontWeight: "bold",
                    pt: 4,
                  }}
                >
                  <b>Exam Started</b>
                </Typography>
              ) : (
                <>
                  <Typography style={fontStyle}>
                    <b>Exam Starts in</b>
                  </Typography>
                  <Typography style={{ fontSize: "20px" }}>
                    <b>
                      {String(timeToStart?.hours).padStart(2, "0")}:
                      {String(timeToStart?.minutes).padStart(2, "0")}:
                      {String(timeToStart?.seconds).padStart(2, "0")}
                    </b>
                  </Typography>
                </>
              )}
            </Box>
          </Grid>
        </Grid>
        <Grid
          item
          p={2}
          mt={2}
          lg={12}
          md={12}
          sx={{
            backgroundColor: "rgba(240, 240, 251, 1)",
            height: "52px",
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderRadius: "8px",
          }}
        >
          <Box>
            <Typography
              sx={{
                color: "rgba(63, 65, 209, 1)",
                fontSize: "16px",
                fontWeight: 500,
              }}
            >
              Instruction
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: "30%",
              gap: "4%",
            }}
          >
            <Typography
              sx={{
                color: "#000",
                fontSize: "16px",
                fontWeight: 500,
                textWrap: "nowrap",
              }}
            >
              Language of Instructions
            </Typography>
            <FormControl fullWidth size="small">
              <InputLabel></InputLabel>
              <Select
                size="small"
                label=""
                onChange={(event) => handleChange(event.target.value, 0)}
                value={selectedLanguage}
              >
                {instructions?.instructions?.map((instruction, index) => (
                  <MenuItem
                    sx={{ textTransform: "capitalize" }}
                    key={index}
                    value={instruction?.language}
                  >
                    {instruction.language.charAt(0).toUpperCase() +
                      instruction.language.slice(1)}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Grid>
        {!projectDetails?.mockMode && (
          <>
            {/* <Typography
              mt={2}
              sx={{
                color: "rgba(63, 65, 209, 1)",
                fontSize: "16px",
                fontWeight: 500,
              }}
            >
              About Question Paper
            </Typography> */}
            {/* <Grid item md={12} pt={2}>
              <DataTable columns={columns} data={data} />
            </Grid> */}
          </>
        )}
        <Typography
          mt={2}
          sx={{
            color: "rgba(63, 65, 209, 1)",
            fontSize: "16px",
            fontWeight: 500,
          }}
        >
          Details
        </Typography>
        <Grid
          item
          md={12}
          sx={{
            lineHeight: "25px",
            height: "200px",
            ml: 0,
            overflowY: "scroll",
            "&::-webkit-scrollbar": {
              width: "8px",
              height: "8px",
            },
            "&::-webkit-scrollbar-track": {
              background: "#e0e0e0",
              borderRadius: "10px",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "blue",
              borderRadius: "10px",
              border: "2px solid #e0e0e0",
              height: "10px",
              paddingBottom: "12px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              background: "darkblue",
            },
          }}
        >
          {filteredInstructions?.map((instruction, index) => (
            <Box value={value} index={index} key={index}>
              <Grid
                className="grid-container"
                p={1}
                sx={{ fontSize: 18 }}
                dangerouslySetInnerHTML={{
                  __html: instruction?.value,
                }}
              />
            </Box>
          ))}
        </Grid>
        {projectDetails?.mockMode && (
          <>
            <Typography
              mt={2}
              sx={{
                color: "rgba(63, 65, 209, 1)",
                fontSize: "16px",
                fontWeight: 500,
              }}
            >
              About Mock Exam
            </Typography>
            <Grid item md={12} pt={2} pb={2}>
              <DataTable
                columns={mockColumns}
                data={data}
                name={"mocktest"}
                handleMockTest={handleMockTest}
              />
            </Grid>
          </>
        )}
        {!projectDetails?.mockMode && (
          <>
            <Grid item md={12} pt={3}>
              <Divider sx={{ width: "100%" }} />
            </Grid>
            <Grid
              item
              md={12}
              pt={2}
              sx={{ display: "flex", alignItems: "center", gap: "1%" }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  flexDirection: "column",
                  height: "98px",
                }}
              >
                <Checkbox
                  checked={checked}
                  onChange={() => {
                    setChecked(!checked);
                    auditLog({
                      data: {
                        RegistrationNumber: `${candidateTokenDetails?.user?.id}`,
                        RollNumber: `${candidateTokenDetails?.user?.rollNo}`,
                        Activity: "User selected check box of Terms and conditions",
                        IPaddress: "",
                      },
                      dispatch,
                      heartBeat,
                    });
                  }}
                  sx={{ margin: 0, padding: 0 }}
                  color="success"
                />
              </Box>
              <Typography sx={{ fontSize: "16px" }}>
                I have read and understand instructions. All computer hardware
                allotted to me are in proper working condition.
                <br />
                I declare that I am not possession of / not wearing / not
                carrying any prohibited gadget like mobile phone, blue tooth
                device etc. / any prohibited material with me into the
                Examination Hall.
                <br />I agree that in case of not adhering to the instructions,
                I shall be liable to debarred from this test and / or to
                disciplinary action.
              </Typography>
            </Grid>
            <Grid item md={12} pt={2} sx={{ display: "flex", gap: "16px" }}>
              {candidateTokenDetails?.configuration?.sampleTestRequired && (
                <SecondaryButton
                  color={"rgba(63, 65, 209, 1)"}
                  border="1px solid rgba(63, 65, 209, 1)"
                  width={"15%"}
                  onClick={() => handleSampleTest()}
                >
                  Sample Test
                </SecondaryButton>
              )}
              <PrimaryButton
                onClick={handleLiveTest}
                width={"15%"}
                disabled={
                  timeLeft?.hours === 0 &&
                  timeLeft?.minutes === 0 &&
                  timeLeft?.seconds === 0 &&
                  timeToStart?.hours === 0 &&
                  timeToStart?.minutes === 0 &&
                  timeToStart?.seconds === 0 &&
                  checked
                    ? false
                    : timeToStart?.hours === 0 &&
                      timeToStart?.minutes === 0 &&
                      timeToStart?.seconds === 0 &&
                      checked
                    ? false
                    : true
                }
                borderRadius={"138px"}
                color={"#000"}
              >
                start live exam
              </PrimaryButton>
            </Grid>
          </>
        )}
      </Grid>
      <RemainingTimeModal
        endExamMinutes={0}
        startExamMinutes={timeToStart?.minutes}
      />
      <NotificationModal />
    </>
  );
}
